import MediaAboutUs from './MediaAboutUs';

export default MediaAboutUs;
